import { Box, Button, Typography, styled } from "@mui/material"

// height for Menu Items
const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8

export const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
}

export const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    height: 300,
    bgcolor: "background.paper",
    boxShadow: "0px 3px 6px #00000029",
    borderRadius: "5px",
}

export const OpportunityModalHeader = styled(Box)({
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px solid #DDDDDC",
    padding: "20px",
})

export const OpportunityDetailsWrapper = styled(Box)({
    padding: "8px 20px 10px 20px",
    position: "relative",
})

export const OpportunityDetailsSubWrapper = styled(Box)({
    display: "flex",
    alignItems: "start",
    flexDirection: "column",
})
export const OpportunityMerticName = styled(Typography)({
    color: "#3C77EF",
    paddingBottom: "10px",
})

export const OpportunityOfficeName = styled(Typography)({
    color: "#000000",
    textTransform: "capitalize",
})

export const OpportunityFields = styled(Box)({
    width: "100%",
    height: "160px",
    marginTop: "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
})

export const OpportunityMerticField = styled(Box)({
    display: "flex",
    justifyContent: "space-between",
})

export const OpportunityMerticFieldOne = styled(Box)({
    width: "215px",
    height: "50px",

    flexGrow: 1,
    marginRight: "35px",
})

export const OpportunityMerticFieldTwo = styled(Box)({
    width: "215px",
    height: "50px",

    flexGrow: 1,
})

export const OpportunityMerticDate = styled(Box)({
    display: "flex",
    justifyContent: "space-between",
})

export const OpportunityMerticStartDateOne = styled(Box)({
    width: "215px",
    height: "50px",

    flexGrow: 1,
    marginRight: "35px",
})

export const OpportunityMerticEndDateTwo = styled(Box)({
    width: "215px",
    height: "50px",

    flexGrow: 1,
})

export const OpportunitySetField = styled(Box)({
    display: "flex",
    justifyContent: "space-between",
})

export const OpportunitySetFieldOne = styled(Box)({
    width: "215px",
    height: "50px",

    flexGrow: 1,
    marginRight: "35px",
})

export const OpportunityButtons = styled(Box)({
    display: "flex",
    justifyContent: "flex-end",

    width: "100%",
})
export const ButtonWrapper = styled(Box)({
    display: "flex",
    justifyContent: "space-evenly",
    width: "400px",
    position: "absolute",
    bottom: "30px",
})

export const OpportunityStatus = styled(Box)({
    width: "259px",
    height: "50px",
    border: "1px solid rgba(0, 0, 0, 0.23) ",
    borderRadius: "4px ",
    padding: " 2px",
    flexGrow: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
})

export const CancelButton = styled(Button)({
    width: "156px",
    height: "48px",
    color: "#707070",
})

export const SetButton: any = styled(Button)({
    width: "156px",
    height: "48px",
    color: "#fff",

    backgroundColor: "#3D76EF",
    "&:hover": {
        backgroundColor: "#3D76EF",
    },
    "&:disabled": {
        color: "#FFFFFF",
        backgroundColor: "#707070",
    },
})

export const ActiveIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19.929"
        height="19.929"
        viewBox="0 0 19.929 19.929"
    >
        <g
            id="Group_35287"
            data-name="Group 35287"
            transform="translate(-378.123 -6079)"
        >
            <g id="图层_x0020_1" transform="translate(378.123 6079)">
                <circle
                    id="Ellipse_515"
                    data-name="Ellipse 515"
                    cx="9.965"
                    cy="9.965"
                    r="9.965"
                    transform="translate(0 0)"
                    fill="#3d76ef"
                />
            </g>
            <g
                id="Layer_2_00000140736130153921798300000016668462501025497243_"
                transform="translate(381.779 5974)"
            >
                <g id="trend_up" transform="translate(-0.006 112)">
                    <path
                        id="Path_12491"
                        data-name="Path 12491"
                        d="M.776,119.1a.781.781,0,0,1-.358-.086A.728.728,0,0,1,0,118.251a1.037,1.037,0,0,1,.244-.518c1.231-1.251,2.467-2.482,3.4-3.412a.818.818,0,0,1,.575-.254.856.856,0,0,1,.607.274l2.122,2.122,2.886-2.889-.291,0-1.169-.007a.753.753,0,0,1-.782-.777.786.786,0,0,1,.22-.565.771.771,0,0,1,.555-.22c.587,0,1.172,0,1.737,0l1.744,0a.735.735,0,0,1,.762.748c.007,1.2.007,2.391,0,3.528a.741.741,0,0,1-.78.745h-.01a.747.747,0,0,1-.77-.765c0-.35,0-.706,0-1.048v-.54a.378.378,0,0,0-.032.03q-1.465,1.469-2.928,2.943l-.407.407a1,1,0,0,1-.7.365.983.983,0,0,1-.683-.355l-2.082-2.087-.175.173c-.183.18-.353.35-.521.518l-.785.789c-.451.454-.918.925-1.379,1.386a.818.818,0,0,1-.592.266Z"
                        transform="translate(0.006 -112)"
                        fill="#fff"
                    />
                </g>
            </g>
        </g>
    </svg>
)

export const ModalHeader = styled(Box)({
    width: "100%",
    height: "30px",
    display: "flex",
    justifyContent: "flex-end",
})

export const ButtonContainer = styled(Box)({
    alignSelf: "flex-end",
    justifySelf: "flex-end",
    display: "flex",
    height: "fit-content",
    justifyContent: "center",
    width: "100%",
    // border: "1px solid red",
    marginTop: "auto",
    // padding: "0 20px"
})

export const OldCancelButton = styled(Box)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "138px",
    height: "40px",
    borderRadius: "4px",
    outline: "1px solid #4A79E7",
    cursor: "pointer"
})

export const ConfirmButton = styled(Box)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "138px",
    height: "40px",
    borderRadius: "4px",
    marginLeft: "38px",
    backgroundColor: "#4A79E7",
    cursor: "pointer"
})